import { __rest } from "tslib";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const ArrowLeftSmall = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M7.85710678,6.14212718 C8.05049539,6.33551579 8.05074179,6.64898459 7.85765744,6.84267698 L5.70710678,9 L14,9 L14,10 L5.70710678,10 L7.85728896,12.1524212 C8.05051745,12.3458509 8.0504359,12.6592741 7.85710678,12.8526033 C7.66371856,13.0459915 7.35025004,13.0462368 7.15655932,12.8531516 L3.79289322,9.5 L7.1568079,6.14182805 C7.35032102,5.94864528 7.66375877,5.94877917 7.85710678,6.14212718 Z" })));
};
ArrowLeftSmall.displayName = 'ArrowLeftSmall';
export default ArrowLeftSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ArrowLeftSmall.js.map